
document.addEventListener('DOMContentLoaded', function () {

  document.querySelectorAll('.text-boxwidth').forEach(box => {
    box.classList.add('js-ready');
  });

  // Select ALL read-more wrappers
  const wrappers = document.querySelectorAll('.read-more-wrapper');

  wrappers.forEach(wrapper => {

    const preview = wrapper.querySelector('.read-more-content.preview');
    const full = wrapper.querySelector('.read-more-content.full');
    const readMoreBtn = preview.querySelector('.read-more-button.read-more');
    const readLessBtn = full.querySelector('.read-more-button.read-less');

    if (!preview || !full || !readMoreBtn || !readLessBtn) return;

    // Detect screen size: 10 for mobile, 40 for desktop
    const isMobile = window.innerWidth <= 768;
    const wordLimit = isMobile ? 10 : 40;

    // Prepare truncation
    const fullHTML = full.innerHTML.replace(/<button[\s\S]*<\/button>/, "");
    const div = document.createElement('div');
    div.innerHTML = fullHTML;

    let wordCount = 0;
    const truncated = document.createElement('div');

    function cloneWithLimit(node) {
      if (wordCount >= wordLimit) return null;

      if (node.nodeType === Node.TEXT_NODE) {
        const words = node.textContent.trim().split(/\s+/).filter(Boolean);
        if (words.length === 0) return null;

        const take = Math.min(wordLimit - wordCount, words.length);
        wordCount += take;

        const text = words.slice(0, take).join(' ');
        return document.createTextNode(text + (wordCount >= wordLimit ? '...' : ' '));
      }

      if (node.nodeType === Node.ELEMENT_NODE) {
        const clone = node.cloneNode(false);
        for (const child of node.childNodes) {
          const limited = cloneWithLimit(child);
          if (limited) clone.appendChild(limited);
          if (wordCount >= wordLimit) break;
        }
        return clone;
      }

      return null;
    }

    for (const child of div.childNodes) {
      const limited = cloneWithLimit(child);
      if (limited) truncated.appendChild(limited);
      if (wordCount >= wordLimit) break;
    }

    // Insert truncated text back into preview
    preview.innerHTML = truncated.innerHTML + ' ';
    preview.appendChild(readMoreBtn);

    // Toggle logic
    readMoreBtn.addEventListener('click', function () {
      preview.style.display = 'none';
      full.classList.add('show');
    });

    readLessBtn.addEventListener('click', function () {
      full.classList.remove('show');
      preview.style.display = 'inline';
    });

  });
});


